/* eslint-disable no-await-in-loop */
import axios from 'axios';
// eslint-disable-next-line import/no-extraneous-dependencies
import { toDataURL } from 'qrcode';
import { Buffer } from 'buffer';
import SparkMD5 from 'spark-md5';
import { isMobile } from 'react-device-detect';
import { v4 as uuidv4 } from 'uuid';
import GenerateLexUserCookie from '../connectivity/GenerateLexUserCookie';
import GenerateLexUserId from '../connectivity/GenerateLexUserId';
import { ADDITIONAL_DETAILS, CUSTOMER_MESSAGE, MESSAGE_BODY } from '../Constants';
import { API_CONFIG } from '../config/apiconfig';
/* eslint-disable  import/no-cycle */
import { encryptData } from '../components/chat/utils/CommonFunctions';

const lexUserId = GenerateLexUserId();
const lexUserCookie = GenerateLexUserCookie();
export const getParameters = ({
  message,
  slotToElicit,
  englishBot,
  sessionID,
  chatDeviceType,
  chatDeviceOS,
  SspUserLogin,
  uuid,
  isEncryptionNeeded,
  dobAtLogin,
  usviCustomer,
  eliteAccountAvailable,
  isConcierge,
  customerName,
}) => {
  let inputMessage = '';
  if (
    slotToElicit === ADDITIONAL_DETAILS ||
    slotToElicit === MESSAGE_BODY ||
    slotToElicit === CUSTOMER_MESSAGE
  ) {
    inputMessage = `<slot>${message}<slot>`;
  } else {
    inputMessage = message;
  }
  const requestAttributes =
    SspUserLogin === 'true'
      ? {
          userId: lexUserId,
          deviceType: chatDeviceType,
          DeviceOS: chatDeviceOS,
          isLoggedIn: 'Y',
          chatbotktc: lexUserCookie,
          isUsviCustomer: usviCustomer,
          isConcierge,
          customerName,
          eliteAccountAvailable,
          dob: dobAtLogin,
        }
      : {
          userId: lexUserId,
          deviceType: chatDeviceType,
          DeviceOS: chatDeviceOS,
          isLoggedIn: 'N',
          chatbotktc: lexUserCookie,
          isConcierge,
          eliteAccountAvailable,
        };

  if (uuid && uuid.length > 0) {
    requestAttributes.DocumentsUUID = uuid.join(',');
  }

  const obj = {
    inputText: inputMessage,
    locale: englishBot ? 'en_US' : 'es_US',
    sessionId: sessionID || '',
    requestAttributes,
  };

  return obj;
};

export const downloadAttachmentFile = async (id, token, accessToken, sessionID, englishBot) => {
  const data = {
    attachmentId: id,
    connectionToken: token,
  };
  const uuid = generateuuid();
  const innerResponse = await axios.post(API_CONFIG.DOWNLOAD_FILE_CALL_API, data, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-api-key': process.env.REACT_APP_X_API_KEY,
      appid: 'comms',
      sessionId: sessionID,
      source: 'Chatbot',
      lang: englishBot ? 'ENG' : 'ESP',
      uuid,
    },
  });

  return innerResponse.data.presignedURL;
};

export const timeConvert = (num) => {
  let hours = Math.floor(num / 60);
  let minutes = num % 60;
  minutes = String(minutes).padStart(2, '0');
  hours = String(hours).padStart(2, '0');
  return `${hours}:${minutes}`;
};
export const disableAllChatButtons = () => {
  const elems = document.getElementsByClassName('quick-reply-button');
  if (elems && elems.length > 0) {
    for (const element of elems) {
      element.disabled = true;
    }
  }
};

export const toggleChatbotContainerSize = (popupRunningFlag) => {
  if (!popupRunningFlag) {
    if ('parentIFrame' in window) {
      window.parentIFrame.getPageInfo((obj) => {
        const winHeight = (obj.windowHeight * 95) / 100;
        if (isMobile) {
          window.parentIFrame.size(winHeight, obj.windowWidth);
        } else {
          window.parentIFrame.size(winHeight, 470);
        }
      });
    }
  }
};

export const deleteSessioApiCall = (englishBot, sessionID, token) => {
  const uuid = generateuuid();
  const deleteResponse = axios.post(
    `${API_CONFIG.DELETE_SESSION_API}`,
    {
      locale: englishBot ? 'en_US' : 'es_US',
      sessionId: sessionID,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'x-api-key': process.env.REACT_APP_X_API_KEY,
        appid: 'comms',
        sessionId: sessionID,
        source: 'Chatbot',
        lang: englishBot ? 'ENG' : 'ESP',
        uuid,
      },
    }
  );
  return deleteResponse;
};
export const focusInChatbot = () => {
  const messageGroup = document.getElementById('messageGroup');
  const messageTextarea = document.getElementById('messageText');
  if (
    messageGroup &&
    messageGroup.lastChild.lastElementChild.querySelectorAll('.quick-replies').length > 0
  ) {
    messageGroup.lastChild.lastElementChild
      .querySelectorAll('.quick-replies')[0]
      .firstChild.focus();
  } else if (messageTextarea) {
    messageTextarea.focus();
  }
};

export const readFileAsDataURL = (file) => {
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onload = (event) => {
      const base64String = event.target.result.split(',')[1];
      resolve(base64String);
    };

    reader.onerror = (err) => {
      reject(err);
    };

    reader.readAsDataURL(file);
  });
};

export const getbase64fromFile = async (fileArr) => {
  if (fileArr) {
    const base64Result = [];
    fileArr.forEach(async (file) => {
      const base64String = await readFileAsDataURL(file);
      base64Result.push(base64String);
    });
    return base64Result;
  }
  return [];
};

export const generateuuid = () => uuidv4();

export const postAttachments = async (
  sessionID,
  uuid,
  formData,
  accessToken,
  fileData,
  englishBot
) => {
  const response = await axios
    .post(
      `${API_CONFIG.FILE_UPLOAD_LESS_THAN_4_MB}/?uuid=${uuid}&eventName=${fileData.eventName}&sessionId=${sessionID}&size=${fileData.size}&source=${fileData.source}&format=${fileData.format}&fileName=${fileData.fileName}&language=${fileData.lang}&info=${fileData.info}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'multipart/form-data',
          appid: 'comms',
          sessionId: sessionID,
          source: 'Chatbot',
          lang: englishBot ? 'ENG' : 'ESP',
          uuid,
        },
      }
    )
    .then(() => true)
    .catch(() => false);
  return response;
};

export const generateFileData = (file) =>
  new Promise((resolve, reject) => {
    const blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
    const chunkSize = 2097152;
    const chunks = Math.ceil(file.size / chunkSize);

    let currentChunk = 0;
    const spark = new SparkMD5.ArrayBuffer();
    const fileReader = new FileReader();

    fileReader.onload = (e) => {
      spark.append(e.target.result);
      currentChunk += 1;

      if (currentChunk < chunks) {
        loadNext();
      } else {
        const hash = spark.end();
        resolve(hash);
      }
    };

    fileReader.onerror = () => {
      reject();
    };
    function loadNext() {
      const start = currentChunk * chunkSize;
      const end = start + chunkSize >= file.size ? file.size : start + chunkSize;
      fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
    }
    loadNext();
  });

export const uploadDocumentByPreSignedURL = async (
  preSignedUrl,
  file,
  fileMd5,
  callbackFunction,
  args
) => {
  let response = null;
  try {
    response = await axios
      .put(preSignedUrl, file, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Content-MD5': fileMd5,
        },
      })
      .then(() => {
        if (args && callbackFunction) {
          const { payload, customerVerifyToken, lang, generateKey, isFileSizeGreaterThan4MB } =
            args;
          return callbackFunction(
            payload,
            customerVerifyToken,
            lang,
            generateKey,
            isFileSizeGreaterThan4MB
          );
        }
      });
  } catch (e) {
    return response;
  }
  return response;
};

export const postFileUpload = async ({
  data,
  uuid,
  token,
  sessionId,
  eventName,
  englishBot,
  callbackFunction = false,
  args = false,
}) => {
  const md5base64 = Buffer.from(data?.contentMD5, 'hex').toString('base64');
  const body = {
    uuid,
    source: 'Chatbot',
    sessionId,
    eventName,
    fileName: data.fileName,
    format: 'pdf',
    size: data.fileSize,
    info: 'File',
    contentMD5: md5base64,
  };
  let response = null;
  try {
    response = await axios
      .post(`${API_CONFIG.FILE_UPLOAD}`, body, {
        headers: {
          Authorization: `Bearer ${token}`,
          appid: 'comms',
          sessionId,
          source: 'Chatbot',
          lang: englishBot ? 'ENG' : 'ESP',
          uuid,
        },
      })
      // eslint-disable-next-line arrow-body-style
      .then((res) => {
        return uploadDocumentByPreSignedURL(
          res?.data?.preSignedUrl,
          data.file,
          md5base64,
          callbackFunction,
          args
        );
      });
  } catch (e) {
    return e.response;
  }
  return response;
};

export const getQRCode = (deviceType) => {
  let qrValue;
  let inputURL;
  if (deviceType === 'DEVICE_TYPE_IPHONE') {
    inputURL = 'https://itunes.apple.com/us/app/ath-m%C3%B3vil/id658539297?mt=8';
  } else {
    inputURL = 'https://play.google.com/store/apps/details?id=com.evertec.athmovil.android&hl=en';
  }
  toDataURL(
    inputURL,
    {
      width: 250,
      margin: 2,
    },
    (err, url) => {
      if (err) {
        return;
      }
      qrValue = url;
    }
  );
  return qrValue;
};
export const getCountriesList = async (englishBot, handleCountriesList, token, sessionID) => {
  const uuid = generateuuid();
  const countriesResponse = await axios
    .get(`${API_CONFIG.GET_COUNTRIES_LIST}/${englishBot ? 'en' : 'es'}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'x-api-key': process.env.REACT_APP_X_API_KEY,
        appid: 'comms',
        sessionId: sessionID,
        source: 'Chatbot',
        lang: englishBot ? 'ENG' : 'ESP',
        uuid,
      },
    })
    .then((res) => {
      handleCountriesList(res.data);
    });
  return countriesResponse;
};

export const submitFeedback = async ({
  uuid,
  language,
  customerEmail,
  customerName,
  customerPhone,
  feedbackInput,
  feedbackRating,
  token,
  sessionID,
}) => {
  const feedbackResponse = await axios.post(
    API_CONFIG.FEEDBACK_SUBMIT_API,
    {
      customerEmail: encryptData(customerEmail, uuid),
      customerName,
      customerPhone: encryptData(customerPhone, uuid),
      feedbackInput,
      feedbackRating,
      sessionID,
    },
    {
      headers: {
        appid: 'comms',
        uuid,
        source: 'Chatbot',
        lang: language,
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return feedbackResponse;
};
